import { createSelector } from 'reselect';
import { RootState } from '../../../../config/store/rootReducer';
import { OrganizationUpdateStep } from '../../types/organization';

const getProfileUpdate = (state: RootState): OrganizationUpdateStep | null => state.organizations.profileUpdate;
export const makeGetProfileUpdate = () =>
  createSelector(getProfileUpdate, (profileUpdateStep: OrganizationUpdateStep | null) => profileUpdateStep);
